import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from 'react';
/**
 * Stack of toast items, rendered into the bottom-right of the viewport.
 * Each toast fades out after its own timer; the stack scrolls so a burst
 * of activity doesn't overflow the viewport.
 */
export function ToastStack({ toasts, onDismiss, }) {
    if (toasts.length === 0)
        return null;
    return (_jsx("div", { className: "kb-toast-stack", role: "region", "aria-live": "polite", "aria-label": "Notifications", children: toasts.map((t) => (_jsx(Toast, { ...t, onDismiss: () => onDismiss(t.id) }, t.id))) }));
}
function Toast({ id, tone, message, onDismiss }) {
    useEffect(() => {
        const t = window.setTimeout(onDismiss, 4500);
        return () => window.clearTimeout(t);
    }, [onDismiss]);
    return (_jsxs("div", { role: tone === 'error' ? 'alert' : 'status', className: `kb-toast kb-toast--${tone}`, "data-toast-id": id, children: [_jsx("span", { className: "kb-toast__msg", children: message }), _jsx("button", { type: "button", "aria-label": "Dismiss", className: "kb-toast__close", onClick: onDismiss, children: "\u00D7" })] }));
}
//# sourceMappingURL=Toast.js.map